"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _portalId = _hubspot.default.get();
/**
 * Keys for localStorage settings.
 *
 * Use format like "Contacts:sidebar_settings"
 */


var _default = {
  DEFAULT_PIPELINE_ID: "defaultPipelineId:" + _portalId,
  DEFAULT_TICKET_PIPELINE_ID: "defaultTicketPipelineId:" + _portalId,
  POST_IMPORT_VIDEO_VISIBILITY: "postImportVideoVisibility:" + _portalId,
  SEGMENTS_FOLDERS_LAST_VIEWED: "segmentsFoldersLastViewed:" + _portalId
};
exports.default = _default;
module.exports = exports.default;